var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c(
      "div",
      { staticClass: "main-container", attrs: { id: "main-container" } },
      [
        _c(
          "div",
          { attrs: { id: "after-sales-list" } },
          [
            _c(
              "van-tabs",
              {
                attrs: { swipeable: "" },
                on: { change: _vm.tabChange },
                model: {
                  value: _vm.tabCurrentIndex,
                  callback: function($$v) {
                    _vm.tabCurrentIndex = $$v
                  },
                  expression: "tabCurrentIndex"
                }
              },
              _vm._l(_vm.tabsConfig, function(item) {
                return _c(
                  "van-tab",
                  { key: item.index, attrs: { title: item.title } },
                  [
                    _c(
                      "van-pull-refresh",
                      {
                        staticClass: "refreshBox",
                        class: { afterSalesListBox: !_vm.listShow },
                        on: { refresh: _vm.onRefresh },
                        model: {
                          value: _vm.isLoading,
                          callback: function($$v) {
                            _vm.isLoading = $$v
                          },
                          expression: "isLoading"
                        }
                      },
                      [
                        _vm.listShow
                          ? _c(
                              "van-list",
                              {
                                attrs: {
                                  finished: _vm.finished,
                                  "finished-text": "没有更多了"
                                },
                                on: { load: _vm.onLoad },
                                model: {
                                  value: _vm.ploading,
                                  callback: function($$v) {
                                    _vm.ploading = $$v
                                  },
                                  expression: "ploading"
                                }
                              },
                              _vm._l(_vm.listData, function(item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.id,
                                    staticClass: "afterSalesList"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "afterSalesType" },
                                      [
                                        _c("div", [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.refundUrl,
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "spanType" },
                                            [_vm._v(_vm._s(item.typeStr))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(item.statusStr))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(item.itemList, function(ele, index) {
                                      return _c(
                                        "van-card",
                                        {
                                          key: index,
                                          attrs: {
                                            title: ele.productName,
                                            thumb: ele.productImg
                                          }
                                        },
                                        [
                                          _c("template", { slot: "desc" }, [
                                            _c("p", { staticClass: "descP" }, [
                                              _vm._v(
                                                _vm._s(ele.specificationValue)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "numP" }, [
                                              _c("div", [
                                                _vm._v("¥" + _vm._s(ele.amount))
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "×" + _vm._s(ele.quantity)
                                                )
                                              ])
                                            ])
                                          ])
                                        ],
                                        2
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "btnStyle" },
                                      [
                                        _c(
                                          "van-button",
                                          {
                                            attrs: { round: "" },
                                            on: {
                                              click: function($event) {
                                                _vm.openGoodDetails(item)
                                              }
                                            }
                                          },
                                          [_vm._v("查看详情")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _c("noData")
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }